export interface ActiveAppFrame {
  iframe: HTMLIFrameElement;
  appInstanceId: string;
  origin: string;
  intendedPath: string;
}

export const activeFrames = new Map<WindowProxy, ActiveAppFrame>();
